 
import ContentTransform from './ContentTransform';

export default class ContentTransformPlugin {
  static install(Vue, options) {
    if (ContentTransformPlugin.installed) {
      return;
    }

    ContentTransformPlugin.installed = true;

    if (!options || (!options.modules && typeof options.modules !== 'object')) {
      throw new Error('ContentTransformPlugin needs an object named modules.');
    }

    const contentTransform = new ContentTransform(options);

    Vue.$contentTransform = contentTransform;

    Object.defineProperties(Vue.prototype, {
      $contentTransform: {
        get() {
          return contentTransform;
        },
      },
    });
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  window.Vue.use(ContentTransformPlugin);
}
